import { useContext } from 'react';

import { ITranslationsCollection } from '@estee/elc-service';

import { VulcanContextProvider } from '~context/VulcanContext';

export const useTranslation = (): ITranslationsCollection => {
    const { translations } = useContext(VulcanContextProvider);

    return translations;
};
